import React from 'react';
import './ServiceSection.scss';
import {Link} from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

const ServiceSection = ({service, loading, ...otherProps}) => {
  
  if (loading)
	return <section className='service-section'>
	  <h2 className='title-loader'><Skeleton/></h2>
	  <p className={'description-loader'}>
		<Skeleton count={2}/>
	  </p>
	  <p className={'description-loader'}>
		<Skeleton count={3}/>
	  </p>
	  <p className={'description-loader'}>
		<Skeleton count={2}/>
	  </p>
	  <div className='action-bar right'>
		<Skeleton style={{width: '120px', height: '36px'}}/>
	  </div>
	</section>;
  
  
  const {title, longDescription, url, imageUrl} = service;
  return (
    <Link to={url} target={'_self'} className="service-section card card-link">
      <div className='card-content-with-image'>
        <div className='card-content'>
          <h2 className='title'>{title}</h2>
          <p dangerouslySetInnerHTML={{__html: longDescription}}></p>
        </div>
        {imageUrl && (
          <div className='card-image-area'>
            <img src={imageUrl} alt={title} className='card-image' />
          </div>
        )}
      </div>
    </Link>
  );
};

export default ServiceSection;
